<template>
	<div class="mg-b-25">
		<p class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 tx-medium mg-b-5">{{ label ? label : 'Current Cash Balance' }}</p>
		<h3 class="tx-26 tx-normal tx-rubik tx-spacing--2 mg-b-5">
			<small class="text-muted tx-light">{{ currency }}</small> {{ trade_balance.at_hand | toNumber }}
			<router-link v-if="showAddFund" class="btn btn-default btn-sm shadow-sm float-right" :to="{ name: 'requests.deposit' }">Add Funds</router-link>
		</h3>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters({
			trade_balance: 'trade/cashBalance',
		}),
	},
	props: ['currency', 'label', 'showAddFund'],
};
</script>

<style>
</style>
